import React from 'react';
import DistributionListContactSummary from './DistributionListContactSummary';
import { withStyles } from '@material-ui/core/styles';
import { FormSpy } from 'react-final-form';
import CustomSimpleForm from '../../core/components/form/CustomSimpleForm';

const styles = () => ({
  fullWidth: {
    width: '100%'
  },
  form: {
    '& > div': {
      paddingTop: '0px !important',
      paddingBottom: '0px !important'
    }
  }
});

const DistributionListContactForm = props => {
  const { handleSubmit, setUserEmailsFormProps, classes, recipients } = props;
  return (
    <CustomSimpleForm
      initialValues={{ users: [] }}
      toolbar={null}
      // We override the redux-form name to avoid collision with the react-admin main form
      resource="users"
      // We override the redux-form onSubmit prop to handle the submission ourselves
      save={handleSubmit}
      className={classes.form}
      variant="standard"
      margin="normal"
    >
      <FormSpy>
        {props => {
          setUserEmailsFormProps(props);
          return (
            <DistributionListContactSummary
              {...props}
              recipients={recipients}
            />
          );
        }}
      </FormSpy>
    </CustomSimpleForm>
  );
};

export default withStyles(styles)(DistributionListContactForm);
